import React from 'react';
import QuickWinTable from '../tables/QuickWinTable/QuickWinTable';
import { useListEnergyAudit } from 'api/audit/EnergyAuditService';
import { useConditionalRender } from 'hooks/useConditionalRender';

interface QuickWinTableSectionProps {
  buildingId: string | undefined;
}

const QuickWinTableSection: React.FC<QuickWinTableSectionProps> = ({
  buildingId,
}) => {
  const { data, isFetching } = useListEnergyAudit(buildingId);
  const { shouldRender } = useConditionalRender({
    isFetching,
    data: data?.energy_audits,
  });

  if (!shouldRender) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-4 h-full">
      <div className="flex w-full justify-between items-center my-2">
        <h3 className="font-bold uppercase py-0.5">Quick wins</h3>
      </div>
      <QuickWinTable isFetching={isFetching} data={data?.energy_audits} />
    </div>
  );
};

export default QuickWinTableSection;
